module.exports = __webpack_public_path__ + "static/5-small-d21dcd8ef16706ed973d6e45697694d9.jpg";